import type { UsageTotal } from "@/terminal/monitoring/monitoring-usage"

export const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format

// A bare date is a calendar day, not UTC midnight, so it reads the same in
// every time zone.
export const formatReset = (value: string) =>
  new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    timeZone: /^\d{4}-\d{2}-\d{2}$/.test(value) ? "UTC" : undefined,
  }).format(new Date(value))

// Pure, so the client's usage view sums totals without loading the usage
// queries.
export const emptyTotal = (): UsageTotal => ({
  known: 0,
  estimated: 0,
  pendingRequests: 0,
  unknownRequests: 0,
})

export const addTotal = (total: UsageTotal, value: UsageTotal) => {
  total.known += value.known
  total.estimated += value.estimated
  total.pendingRequests += value.pendingRequests
  total.unknownRequests += value.unknownRequests
}
